/**
 * `oneOff` translations -- the One-off payslips tab of Payroll (`pages/payroll/OneOffPayslips.tsx`)
 * and the one-off section of My payslips.
 */
export const oneOff = {
  mn: {
    oneOff: {
      tab: 'Нэг удаагийн',
      title: 'Нэг удаагийн цалингийн хуудас',
      hint: 'Сарын цалингаас гадуур олгох дүн: урамшуулал, залруулга эсвэл ажлаас гарсан хүний чөлөөний нөхөн олговор. НДШ болон татварыг тухайн сарын баталгаажсан цалинтай хамт тооцно.',
      year: 'Он',
      new: 'Шинэ нэг удаагийн',
      empty: 'Энэ онд нэг удаагийн цалингийн хуудас алга.',
      loadFailed: 'Нэг удаагийн цалингийн хуудсыг ачаалж чадсангүй.',
      col: {
        person: 'Ажилтан',
        payDate: 'Олгох огноо',
        month: 'Тооцогдох сар',
        status: 'Төлөв',
        gross: 'Нийт',
        net: 'Цэвэр',
        bank: 'Банк',
      },
      status: { Draft: 'Ноорог', Issued: 'Баталгаажсан', Void: 'Хүчингүй' },
      kind: {
        leave_payout: 'Чөлөөний нөхөн олговор',
        bonus: 'Урамшуулал',
        correction: 'Залруулга',
        other: 'Бусад',
      },
      leaverLabel: 'Ажлаас гарахад олгох чөлөөний нөхөн олговор',
      term: {
        cl: 'Энгийн чөлөө (CL)',
        psl: 'Цалинтай өвчний чөлөө (PSL)',
        al: 'Ээлжийн амралт (AL)',
        al_prepaid: 'Урьдчилж олгосон ээлжийн амралт',
        al_deduct: 'Хуримтлуулснаас илүү эдэлсэн ээлжийн амралт (зөвхөн өдөр)',
      },
      person: 'Ажилтан',
      pickPerson: 'Ажилтан сонгох',
      payDate: 'Олгох огноо',
      reason: 'Шалтгаан',
      lines: 'Олгох дүн',
      addLine: 'Мөр нэмэх',
      removeLine: 'Мөр устгах',
      lineKind: 'Төрөл',
      lineLabel: 'Тайлбар',
      lineAmount: 'Дүн',
      problem: {
        personMissing: 'Ажилтан сонгох.',
        dateMissing: 'Олгох огноог оруулна уу.',
        noLines: 'Дор хаяж нэг мөр нэмнэ үү.',
        labelMissing: 'Мөр бүрт тайлбар бичнэ үү.',
        amountInvalid: 'Дүнг 2 хүртэлх оронтой тоогоор оруулна уу.',
        negativeOnlyCorrection: 'Хасах дүнг зөвхөн залруулга мөрөнд оруулна.',
      },
      working: 'Тооцоо',
      previewHint: 'Баталгаажуулах үед ийм дүнгээр тооцогдоно; юу ч хадгалагдаагүй.',
      previewFailed: 'Тооцоог гаргаж чадсангүй.',
      gross: 'Нийт дүн',
      socialCap: 'Сарын НДШ-ийн дээд хязгаар',
      noCap: 'хязгааргүй',
      insuredBefore: 'Энэ сард бусад цалингаар даатгуулсан',
      capLeft: 'Үлдсэн хязгаар',
      socialBase: 'НДШ тооцох дүн',
      social: 'НДШ',
      socialHow: 'код {{code}}, {{percent}}',
      exempt: 'чөлөөлөгдсөн',
      taxBase: 'Татвар ногдох дүн',
      tax: 'ХХОАТ',
      net: 'Олгох цэвэр дүн',
      payout: 'Чөлөөний нөхөн олговрын тооцоо',
      payoutTotal: 'Нөхөн олговрын нийт дүн',
      days: 'Өдөр',
      dayValue: 'Өдрийн дүн',
      amount: 'Дүн',
      saveDraft: 'Ноорог хадгалах',
      saved: 'Ноорог хадгалагдлаа.',
      edit: 'Засах',
      issue: 'Баталгаажуулах',
      issueConfirm: '{{name}}-д {{net}} цэвэр дүнтэй нэг удаагийн цалингийн хуудсыг баталгаажуулах уу? Дараа нь зөвхөн хүчингүй болгож болно.',
      issueLeaverConfirm: '{{name}}-ийн ажлаас гарах тооцоог баталгаажуулах уу? Нөхөн олговор төлөгдсөнд тооцогдож, чөлөөний үлдэгдэл 0 болж, ажилтан идэвхгүй болно.',
      issued: 'Баталгаажлаа.',
      discard: 'Ноорог устгах',
      discardConfirm: 'Энэ ноорог хүчингүй болно. Үргэлжлүүлэх үү?',
      discarded: 'Ноорог хүчингүй боллоо.',
      void: 'Хүчингүй болгох',
      voidReason: 'Хүчингүй болгох шалтгаан',
      voidReissue: 'Оронд нь шинэ ноорог үүсгэх',
      voided: 'Хүчингүй боллоо.',
      mail: 'Илгээх',
      mailQueued: '{{to}} руу илгээхээр дараалалд орлоо.',
      mailQueuedPersonal: 'Хувийн хаяг {{to}} руу илгээхээр дараалалд орлоо.',
      mailAlready: 'Аль хэдийн илгээгдсэн.',
      mailSuppressed: 'Автомат и-мэйл унтраалттай тул илгээгдсэнгүй.',
      mailSkipped: 'Илгээгдсэнгүй: {{reason}}',
      noPersonalAddress: 'хувийн и-мэйл хаяг бүртгэлгүй; ажлаас гарсан хүний ажлын хаяг руу илгээдэггүй',
      noAddress: 'и-мэйл хаяг бүртгэлгүй',
      notIssued: 'батлагдаагүй байна',
      pdf: 'PDF',
      pdfFailed: 'PDF татаж чадсангүй.',
      bankFile: 'Банкны файл',
      bankFileFor: '{{month}}-ийн баталгаажсан нэг удаагийн цалингийн банкны файл',
      bankNone: 'Энэ сард баталгаажсан нэг удаагийн цалин алга.',
      bankNoneUnsent: 'Энэ сард илгээгээгүй баталгаажсан нэг удаагийн цалин алга. Илгээснийг дахин гаргах бол «Илгээснийг оруулах»-ыг сонгоно уу.',
      bankIncludeSent: 'Илгээснийг оруулах',
      bankWithheld: '{{count}} хүн файлд ороогүй: {{names}}',
      bankSent: 'Банкны файлд орсон',
      notSent: 'Ороогүй',
      draftNote: 'Ноорог: баталгаажаагүй тул дүн өөрчлөгдөж болно.',
      voidNote: 'Хүчингүй: {{reason}}',
      close: 'Хаах',
      cancel: 'Болих',
      mine: 'Нэг удаагийн цалингийн хуудас',
      mineEmpty: 'Энэ хугацаанд нэг удаагийн цалин алга.',
      closeoutRouted: 'Энэ тооцоог нэг удаагийн цалингийн хуудсаар олгоно: баталгаажуулахад төлөгдсөнд тооцогдоно, ноорогийг устгахад тооцоо хүчингүй болно.',
      openTab: 'Нэг удаагийн цалин руу очих',
      payoutLineFixed: 'Энэ мөрийг ажлаас гарах тооцоо тогтоосон тул өөрчлөхгүй.',
      warn: { social_band_missing: 'Олгох огноонд энэ хүнд НДШ-ийн ангилал тогтоогоогүй тул баталгаажуулах боломжгүй.' },
    },
  },
  en: {
    oneOff: {
      tab: 'One-off',
      title: 'One-off payslips',
      hint: 'Pay outside the monthly runs: a bonus, a correction, or a leaver’s leave payout. Social insurance and tax are worked out together with the month’s issued payslips.',
      year: 'Year',
      new: 'New one-off',
      empty: 'No one-off payslips this year.',
      loadFailed: 'The one-off payslips did not load.',
      col: {
        person: 'Person',
        payDate: 'Pay date',
        month: 'Counts in',
        status: 'Status',
        gross: 'Gross',
        net: 'Net',
        bank: 'Bank',
      },
      status: { Draft: 'Draft', Issued: 'Finalized', Void: 'Void' },
      kind: {
        leave_payout: 'Leave payout',
        bonus: 'Bonus',
        correction: 'Correction',
        other: 'Other',
      },
      leaverLabel: 'Leave payout on leaving',
      term: {
        cl: 'Compensatory leave (CL)',
        psl: 'Paid sick leave (PSL)',
        al: 'Annual leave (AL)',
        al_prepaid: 'Annual leave already paid in advance',
        al_deduct: 'Annual leave taken beyond what was earned (days only)',
      },
      person: 'Person',
      pickPerson: 'Choose a person',
      payDate: 'Pay date',
      reason: 'Reason',
      lines: 'What is paid',
      addLine: 'Add a line',
      removeLine: 'Remove line',
      lineKind: 'Kind',
      lineLabel: 'Description',
      lineAmount: 'Amount',
      problem: {
        personMissing: 'Choose a person.',
        dateMissing: 'Enter the pay date.',
        noLines: 'Add at least one line.',
        labelMissing: 'Give every line a description.',
        amountInvalid: 'Enter each amount as a number with at most two decimals.',
        negativeOnlyCorrection: 'Only a correction line can take a negative amount.',
      },
      working: 'Working',
      previewHint: 'What Issue would pay now. Nothing is saved yet.',
      previewFailed: 'The working could not be worked out.',
      gross: 'Gross',
      socialCap: 'Social insurance cap for the month',
      noCap: 'no cap',
      insuredBefore: 'Already insured this month by other payslips',
      capLeft: 'Cap left',
      socialBase: 'Social insurance base',
      social: 'Social insurance',
      socialHow: 'code {{code}}, {{percent}}',
      exempt: 'exempt',
      taxBase: 'Taxable',
      tax: 'Income tax',
      net: 'Net paid',
      payout: 'How the leave payout is worked out',
      payoutTotal: 'Leave payout total',
      days: 'Days',
      dayValue: 'Day value',
      amount: 'Amount',
      saveDraft: 'Save draft',
      saved: 'Draft saved.',
      edit: 'Edit',
      issue: 'Finalize',
      issueConfirm: 'Issue this one-off payslip to {{name}} with {{net}} net? After that it can only be voided.',
      issueLeaverConfirm: 'Issue {{name}}’s leaving payout? The payout is marked paid, their leave balances go to zero and they become Inactive.',
      issued: 'Finalized.',
      discard: 'Discard draft',
      discardConfirm: 'This draft will be voided. Go ahead?',
      discarded: 'Draft discarded.',
      void: 'Void',
      voidReason: 'Why it is voided',
      voidReissue: 'Start a new draft in its place',
      voided: 'Voided.',
      mail: 'Send',
      mailQueued: 'Queued to {{to}}.',
      mailQueuedPersonal: 'Queued to their personal address, {{to}}.',
      mailAlready: 'Already sent.',
      mailSuppressed: 'Automatic mail is switched off, so nothing was sent.',
      mailSkipped: 'Not sent: {{reason}}',
      noPersonalAddress: 'no personal address on file, and someone who has left is never mailed at work',
      noAddress: 'no e-mail address on file',
      notIssued: 'it is not issued',
      pdf: 'PDF',
      pdfFailed: 'The PDF did not download.',
      bankFile: 'Bank file',
      bankFileFor: 'Bank file for the issued one-offs counted in {{month}}',
      bankNone: 'No issued one-offs count in this month.',
      bankNoneUnsent: 'No unsent issued one-offs count in this month. To export ones already sent again, tick “Include already sent”.',
      bankIncludeSent: 'Include already sent',
      bankWithheld: '{{count}} left out of the file: {{names}}',
      bankSent: 'In a bank file',
      notSent: 'Not yet',
      draftNote: 'Draft: not issued yet, so every figure may still change.',
      voidNote: 'Void: {{reason}}',
      close: 'Close',
      cancel: 'Cancel',
      mine: 'One-off payslips',
      mineEmpty: 'No one-off payslips in this period.',
      closeoutRouted: 'A one-off payslip pays this close-out: issuing it marks the payout paid, and discarding its draft voids the close-out.',
      openTab: 'Open one-off payslips',
      payoutLineFixed: 'The leaving close-out set this line, so it cannot change here.',
      warn: { social_band_missing: 'This person has no social insurance band in force on the pay date, so it cannot be issued.' },
    },
  },
  ru: {
    oneOff: {
      tab: 'Разовые',
      title: 'Разовые расчётные листы',
      hint: 'Выплаты вне месячных расчётов: премия, корректировка или компенсация отпуска при увольнении. Соцстрахование и налог считаются вместе с выпущенными листами за месяц.',
      year: 'Год',
      new: 'Новый разовый',
      empty: 'В этом году разовых расчётных листов нет.',
      loadFailed: 'Не удалось загрузить разовые расчётные листы.',
      col: {
        person: 'Сотрудник',
        payDate: 'Дата выплаты',
        month: 'Учитывается в',
        status: 'Статус',
        gross: 'Начислено',
        net: 'К выплате',
        bank: 'Банк',
      },
      status: { Draft: 'Черновик', Issued: 'Утверждён', Void: 'Аннулирован' },
      kind: {
        leave_payout: 'Компенсация отпуска',
        bonus: 'Премия',
        correction: 'Корректировка',
        other: 'Прочее',
      },
      leaverLabel: 'Компенсация отпуска при увольнении',
      term: {
        cl: 'Компенсационный отпуск (CL)',
        psl: 'Оплачиваемый больничный (PSL)',
        al: 'Ежегодный отпуск (AL)',
        al_prepaid: 'Ежегодный отпуск, оплаченный заранее',
        al_deduct: 'Отпуск сверх заработанного (только дни)',
      },
      person: 'Сотрудник',
      pickPerson: 'Выберите сотрудника',
      payDate: 'Дата выплаты',
      reason: 'Причина',
      lines: 'Что выплачивается',
      addLine: 'Добавить строку',
      removeLine: 'Удалить строку',
      lineKind: 'Тип',
      lineLabel: 'Описание',
      lineAmount: 'Сумма',
      problem: {
        personMissing: 'Выберите сотрудника.',
        dateMissing: 'Укажите дату выплаты.',
        noLines: 'Добавьте хотя бы одну строку.',
        labelMissing: 'Дайте каждой строке описание.',
        amountInvalid: 'Введите сумму числом, не более двух знаков после запятой.',
        negativeOnlyCorrection: 'Отрицательная сумма допустима только в корректировке.',
      },
      working: 'Расчёт',
      previewHint: 'Столько выплатит выпуск сейчас. Пока ничего не сохранено.',
      previewFailed: 'Не удалось рассчитать.',
      gross: 'Начислено',
      socialCap: 'Предел соцстрахования за месяц',
      noCap: 'без предела',
      insuredBefore: 'Уже застраховано в этом месяце другими листами',
      capLeft: 'Остаток предела',
      socialBase: 'База соцстрахования',
      social: 'Соцстрахование',
      socialHow: 'код {{code}}, {{percent}}',
      exempt: 'освобождено',
      taxBase: 'Облагаемая сумма',
      tax: 'НДФЛ',
      net: 'К выплате',
      payout: 'Расчёт компенсации отпуска',
      payoutTotal: 'Итого компенсация',
      days: 'Дни',
      dayValue: 'Стоимость дня',
      amount: 'Сумма',
      saveDraft: 'Сохранить черновик',
      saved: 'Черновик сохранён.',
      edit: 'Изменить',
      issue: 'Утвердить',
      issueConfirm: 'Выпустить разовый лист для {{name}} на {{net}} к выплате? После этого его можно только аннулировать.',
      issueLeaverConfirm: 'Выпустить расчёт при увольнении {{name}}? Компенсация считается выплаченной, остатки отпуска обнуляются, сотрудник становится неактивным.',
      issued: 'Утверждён.',
      discard: 'Удалить черновик',
      discardConfirm: 'Черновик будет аннулирован. Продолжить?',
      discarded: 'Черновик аннулирован.',
      void: 'Аннулировать',
      voidReason: 'Причина аннулирования',
      voidReissue: 'Создать новый черновик взамен',
      voided: 'Аннулирован.',
      mail: 'Отправить',
      mailQueued: 'Поставлено в очередь на {{to}}.',
      mailQueuedPersonal: 'Поставлено в очередь на личный адрес {{to}}.',
      mailAlready: 'Уже отправлено.',
      mailSuppressed: 'Автоматическая почта выключена, ничего не отправлено.',
      mailSkipped: 'Не отправлено: {{reason}}',
      noPersonalAddress: 'нет личного адреса, а уволившемуся на рабочий адрес не пишем',
      noAddress: 'нет адреса e-mail',
      notIssued: 'он не выпущен',
      pdf: 'PDF',
      pdfFailed: 'Не удалось скачать PDF.',
      bankFile: 'Банковский файл',
      bankFileFor: 'Банковский файл по выпущенным разовым листам за {{month}}',
      bankNone: 'В этом месяце выпущенных разовых листов нет.',
      bankNoneUnsent: 'В этом месяце нет неотправленных выпущенных разовых листов. Чтобы выгрузить уже отправленные снова, отметьте «Включить уже отправленные».',
      bankIncludeSent: 'Включить уже отправленные',
      bankWithheld: 'Не вошли в файл ({{count}}): {{names}}',
      bankSent: 'В банковском файле',
      notSent: 'Ещё нет',
      draftNote: 'Черновик: ещё не выпущен, суммы могут измениться.',
      voidNote: 'Аннулирован: {{reason}}',
      close: 'Закрыть',
      cancel: 'Отмена',
      mine: 'Разовые расчётные листы',
      mineEmpty: 'За этот период разовых листов нет.',
      closeoutRouted: 'Этот расчёт выплачивается разовым листом: его выпуск отмечает выплату, а удаление черновика аннулирует расчёт.',
      openTab: 'Открыть разовые листы',
      payoutLineFixed: 'Эту строку задал расчёт при увольнении, здесь её не изменить.',
      warn: { social_band_missing: 'На дату выплаты у сотрудника нет категории соцстрахования, выпустить нельзя.' },
    },
  },
}
